/* src/app/features/renuncia/consulta-protocolo/protocolo-renuncia-pesquisa.component.scss */
.botoes {
  display: flex;
  justify-content: right;
  align-items: center;
}
.botoes .btnLimpar {
  margin: 4px;
}
.botoes .btnPesquisar {
  margin: 4px;
}
/*# sourceMappingURL=protocolo-renuncia-pesquisa.component.css.map */
